import React from 'react';
import { Link } from 'react-router-dom';

import logo from '../../assets/icons/team_cap_icon.svg';
import mainImage from '../../assets/images/teamcap-logo-with-name.png';

interface ContainerProps {
  children: React.ReactNode;
  title?: string;
  headingClassName?: string;
  isLoginPage?: boolean;
}

const AuthContainer = ({ children }: ContainerProps) => {
  return (
    <>
      <section className="relative flex w-full h-screen overflow-hidden">
        <div className="absolute h-screen bg-transparent z-10 w-screen overflow-y-scroll scrollbar-hide overflow-x-hidden">
          {/* md:ml-10 xs:px-10  */}
          <div className="xl:w-[600px] min-h-screen bg-white px-20 pt-6 lg:w-1/2 md:w-1/2 xs:w-full xs:px-10 ">
            <div className="w-full">
              <div className="mt-10 mb-10 md:mt-[60px] md:mb-[100px]">
                <Link to="/login" className="flex">
                  <img
                    src={logo}
                    alt="teamcap"
                    className="h-7 w-10 mt-3 mr-2"
                  />
                  <div className=" h-8 text-blue-950 text-[34px] font-Gilroy">
                    TeamCap
                  </div>
                </Link>
              </div>
              {children}
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-indigo-700 via-sky-600 to-cyan-500 min-h-screen absolute md:object-cover md:w-[60%] xs:hidden right-0 flex align-middle justify-center items-center">
          <div className="relative pr-[33px]">
            <img
              src={mainImage}
              alt="teamcap"
              className="h-[65px] w-[81px] mt-3"
            />
          </div>
          <div className="text-white text-[64px] font-normal font-Gilroy">
            TeamCap
          </div>
        </div>
      </section>
    </>
  );
};
export default AuthContainer;
